import useragent from '@finance/useragent';
import { domain, getInstance } from '@finance/domain';
import { APP, RUN_APP } from '../env';
const ENV = getInstance().env;
const isKn = RUN_APP === APP.kn;
const isCompanyApp = useragent.isKaniu || useragent.isSuishouji;
/**
 * 贷款中转页
 *
 * 可配置参数如下：
 *
 * from : 页面来源，目前有 'act' | 'other' 默认 'act'，不在这两个选项当中的，都认为 ‘act’
 *  act: 对应活动跳转来
 *  other: 对应优惠券、现金红包列表跳转来
 *
 * nav： 携带到贷款页面的nav参数，默认 'kaniufanxiquan' | 'suishoufanxiquan'
 *  参数替换默认，携带到贷款页面
 *
 * inner_media：内媒体参数，如果携带过来，则会添加到瑞贷/瑞贷的url上
 */
export const LOAN_TRANSFER_URL = `${domain.res}/act/loan-transfer-page/index.html`;
/** 我的红包/提现页面/红包账户 */
export const WITHDRAW_URL = `${domain.res}/public-vue/shop-operation-account/index.html#/home`;
/** 外部下载SSJ页面 */
export const DOWNLOAD_SSJ_URL = domain.res + '/act/loan-through/index.html';
/** 随心中转 */
export const SUIXIN_URL = `${domain.res}/public-vue/loan-straight/index.html#/indexLoading?type=3`;
/** 随手中转 */
export const SUISHOU_URL = `${domain.res}/public-vue/loan/index.html#/indexLoading`;
/** 福袋中转 - 信贷2 */
export const FUDAI_URL = `${domain.res}/public-vue/loan-front-common/index.html?productId=L0003#/`;
/** 瑞贷中转 - 信贷1 */
export const RUIDAI_URL = (() => {
    let url;
    let query;
    if (ENV === 'local' || ENV === 'dev' || ENV === 'test') {
        url = 'http://tg.feidee.net/kaniu-credit-fe-loan/index.html#/transition';
    }
    else if (ENV === 'uat') {
        url = 'https://uat-kncreditcenter.cardniu.com/kaniuloan/index.html#/transition';
    }
    else {
        url = 'https://kncreditcenter.cardniu.com/kaniuloan/index.html#/transition';
    }
    if (isKn) {
        query = 'productCode=SUIXINYONG&nav=kaniulaxin';
    }
    else {
        query = 'productCode=SUIXINYONG&channelCode=suishouji_SUIXINYONG&nav=suishoulaxin';
    }
    return url + '?' + query;
})();
/** 贷款首页 */
export const LOAN_INDEX_URL = (() => {
    let url;
    // 卡牛IOS
    let iosKn = '/loan/loan-entry/?app=kn';
    // 卡牛安卓
    let androidKn = '/loan/loan-market/index.html';
    if (isKn) {
        if (useragent.isAndroid) {
            if (ENV === 'local' || ENV === 'dev' || ENV === 'test') {
                url = 'https://loantest.cardniu.com' + androidKn;
            }
            else if (ENV === 'uat') {
                url = 'https://xduat.cardniu.com' + androidKn;
            }
            else {
                url = 'https://www.cardniu.com' + androidKn;
            }
        }
        else if (ENV === 'local' || ENV === 'dev' || ENV === 'test') {
            url = 'https://test.cardniu.com' + iosKn;
        }
        else if (ENV === 'uat') {
            url = 'https://uat.cardniu.com' + iosKn;
        }
        else {
            url = 'https://www.cardniu.com' + iosKn;
        }
    }
    else {
        url = 'https://t.feidee.com/myCashNow';
    }
    return url;
})();
/**
 * 跳转优惠券列表
 * @desc 卡牛侧，外部app暂时无法跳转到对应tab
 */
export const COUPON_LIST_URL = (() => {
    if (isKn) {
        return !isCompanyApp
            ? 'https://t.cardniu.com/bondCenter'
            : 'cardniu://app/bondCenter';
    }
    return `${domain.res}/public-vue/loan-operation-tool/index.html#/coupon/list?type=2`;
})();
const _default = {
    WITHDRAW_URL,
    DOWNLOAD_SSJ_URL,
    SUIXIN_URL,
    SUISHOU_URL,
    FUDAI_URL,
    RUIDAI_URL,
    LOAN_INDEX_URL,
    COUPON_LIST_URL,
    LOAN_TRANSFER_URL,
};
export default _default;
